import { render, staticRenderFns } from "./DomicilioCambioComponent.vue?vue&type=template&id=8117a446"
import script from "./DomicilioCambioComponent.vue?vue&type=script&lang=js"
export * from "./DomicilioCambioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports